import { isPrrMode } from "./config";

export function getDashboardRoute(): string {
  return "/dashboard";
}

export function getSessionRoute(sessionId: string, projectId?: string): string {
  if (isPrrMode()) {
    return `/dashboard/session/${sessionId}`;
  }
  return `/dashboard/project/${projectId}/session/${sessionId}`;
}

export function getProjectRoute(projectId?: string): string {
  if (isPrrMode()) {
    return "/dashboard";
  }
  return `/dashboard/project/${projectId}`;
}

